export const ZapOperations = "zapOperations";
export const FormsSetup = "formsSetup";
export const TablesOperations = "tablesOperations";

export interface RawRecipeData {
  id: typeof ZapOperations | typeof FormsSetup | typeof TablesOperations;
  description: string;
  keywords: string[];
}

// Raw recipe data is the baseline text-based recipe data that does not include associated tools.
export const rawRecipeData: RawRecipeData[] = [
  {
    id: ZapOperations,
    description:
      "Complete Zap workflow management - create new Zap workflows, configure existing ones, handle authentication, map fields, and test automations. This recipe provides all tools and guidance needed for any Zap-related task from creation to deployment. Use this when you need to create a new automation workflow, configure field mappings between steps, handle authentication setup, troubleshoot Zap issues, or perform any Zapier workflow operations.",
    keywords: [
      // Creation keywords
      "create zap",
      "build zap",
      "zap creation",
      "workflow creation",
      "new automation",
      "zap skeleton",
      "zap structure",
      "workflow setup",
      "automation framework",
      "zap schema",
      "initial setup",
      "workflow foundation",
      "trigger setup",
      "action setup",
      "app implementation",
      "automation creation",
      "workflow building",
      "zap template",
      // Configuration keywords
      "field mapping",
      "zap configuration",
      "parameter setup",
      "data mapping",
      "workflow configuration",
      "field references",
      "step configuration",
      "zap parameters",
      "data flow",
      "field connections",
      "automation setup",
      "zapier fields",
      "configure zap",
      "map fields",
      "connect data",
      "field format",
      "step references",
      "setup zap",
      "turn on zap",
      // Authentication keywords
      "authentication",
      "auth setup",
      "app connection",
      "connect app",
      "oauth",
      "api keys",
      // General keywords
      "zap recipes",
      "zapier",
      "automation",
      "workflow",
      "integration",
      "zap operations",
      "modify zap",
      "edit zap",
      "update zap",
      "fix zap",
      "troubleshoot zap",
    ],
  },
  {
    id: FormsSetup,
    description:
      "Comprehensive guide for Zapier Forms creation and management workflows. This recipe provides detailed guidance for creating forms, managing pages, working with form APIs, handling form limits, configuring user interactions, and implementing form best practices. Use this when creating forms, managing form pages, working with form configurations, setting up form from table workflows, or implementing any form operations.",
    keywords: [
      "forms",
      "form creation",
      "form setup",
      "form configuration",
      "form management",
      "form pages",
      "form operations",
      "form workflows",
      "form from table",
      "form limits",
      "form api",
      "form endpoints",
      "page creation",
      "page management",
      "form patterns",
      "form development",
      "form best practices",
      "ui setup",
      "form recipes",
      "create form",
      "form builder",
      "form templates",
      "form deployment",
      "form publishing",
      "edit form",
      "update form",
    ],
  },
  {
    id: TablesOperations,
    description:
      "Comprehensive guide for Tables operations and workflows. This recipe provides specific guidance for creating, managing, and working with Zapier Tables, including field management, record operations, usage limits, and best practices. Use this when creating tables, managing table data, checking table limits, or performing any table-related operations.",
    keywords: [
      "tables",
      "table creation",
      "table management",
      "table fields",
      "table records",
      "table data",
      "table limits",
      "table usage",
      "table operations",
      "database",
      "data storage",
      "record management",
      "table configuration",
      "table api",
      "table endpoints",
      "table workflows",
      "table best practices",
      "create table",
      "build table",
      "make table",
      "update table",
    ],
  },
];
